// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"745":"0020809f","786":"e9aa60fb"}[chunkId] + ".css";
};